import { render, staticRenderFns } from "./PageEditorContentForm.vue?vue&type=template&id=50a5639e&scoped=true"
import script from "./PageEditorContentForm.vue?vue&type=script&lang=js"
export * from "./PageEditorContentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5639e",
  null
  
)

export default component.exports